import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Zap, X } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const MESSAGES = {
  challenges: {
    es: {
      title: 'Limite de desafios alcanzado',
      description: 'El plan gratuito incluye 1 desafio. Actualiza tu plan para publicar desafios ilimitados.',
      cta: 'Actualizar a Starter - USD 39/mes',
    },
    en: {
      title: 'Challenge limit reached',
      description: 'Free plan includes 1 challenge. Upgrade to publish unlimited challenges.',
      cta: 'Upgrade to Starter - USD 39/mo',
    },
  },
  applications: {
    es: {
      title: 'Desbloquea todas las postulaciones',
      description: 'Has visto las primeras 20 postulaciones. Actualiza tu plan para ver todas las postulaciones y contactar a los candidatos.',
      cta: 'Actualizar a Starter - USD 39/mes',
    },
    en: {
      title: 'Unlock all applications',
      description: "You've seen the first 20 applications. Upgrade to view all applications and contact candidates.",
      cta: 'Upgrade to Starter - USD 39/mo',
    },
  },
  export: {
    es: {
      title: 'Exportar datos',
      description: 'La exportacion de datos no esta disponible en el plan gratuito. Actualiza tu plan para descargar postulaciones en Excel.',
      cta: 'Actualizar a Starter - USD 39/mes',
    },
    en: {
      title: 'Export data',
      description: 'Data export is not available on the free plan. Upgrade to download applications as Excel.',
      cta: 'Upgrade to Starter - USD 39/mo',
    },
  },
  ai_evaluators: {
    es: {
      title: 'Limite de evaluadores IA alcanzado',
      description: 'El plan gratuito incluye 1 evaluador IA. Actualiza tu plan para usar multiples evaluadores IA simultaneamente.',
      cta: 'Actualizar a Starter - USD 39/mes',
    },
    en: {
      title: 'AI evaluator limit reached',
      description: 'Free plan includes 1 AI evaluator. Upgrade to use multiple AI evaluators simultaneously.',
      cta: 'Upgrade to Starter - USD 39/mo',
    },
  },
};

export const PaywallModal = ({ open, onClose, trigger = 'applications' }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  if (!open) return null;

  const t = MESSAGES[trigger]?.[language] || MESSAGES.applications[language];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="paywall-modal">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 z-10">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          data-testid="paywall-close-btn"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex justify-center mb-5">
          <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: '#f3f0ff' }}>
            <Lock className="w-8 h-8" style={{ color: '#6949b6' }} />
          </div>
        </div>

        <h2 className="text-xl font-bold text-gray-900 text-center mb-2" data-testid="paywall-title">
          {t.title}
        </h2>
        <p className="text-sm text-gray-600 text-center mb-6">
          {t.description}
        </p>

        <Button
          className="w-full text-white font-semibold py-3"
          style={{ backgroundColor: '#6949b6' }}
          onClick={() => navigate('/pricing')}
          data-testid="paywall-upgrade-btn"
        >
          <Zap className="w-4 h-4 mr-2" />
          {t.cta}
        </Button>

        <p className="text-xs text-gray-400 text-center mt-4">
          {language === 'es'
            ? 'Cancela en cualquier momento. Sin compromisos.'
            : 'Cancel anytime. No commitments.'}
        </p>
      </div>
    </div>
  );
};

export default PaywallModal;
